import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import lazyImport from '~/utils/lazyImport';

const TransactionsRulesInitPage = lazyImport(() => import('~/views/transactions-rules/TransactionsRulesInitPage'));
const TransactionsRulesWelcomePage = lazyImport(
  () => import('~/views/transactions-rules/TransactionsRulesWelcomePage'),
);
const NewTransactionsRulePage = lazyImport(() => import('~/views/transactions-rules/NewTransactionsRulePage'));
const EditTransactionsRulePage = lazyImport(() => import('~/views/transactions-rules/EditTransactionsRulePage'));
const TransactionsRulesListPage = lazyImport(() => import('~/views/transactions-rules/TransactionsRulesListPage'));

export const transactionsRulesRoutes: RouteObject[] = [
  {
    index: true,
    element: <TransactionsRulesInitPage />,
  },
  {
    path: ':direction/welcome',
    element: <TransactionsRulesWelcomePage />,
  },
  {
    path: ':direction/new',
    element: <NewTransactionsRulePage />,
  },
  {
    path: 'edit/:ruleId',
    element: <EditTransactionsRulePage />,
  },
  {
    path: ':direction/list',
    element: <TransactionsRulesListPage />,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.Transactions.buildLink()} replace />,
  },
];
